import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import CssBaseline from '@mui/material/CssBaseline';
import telxiraTheme from '../themes/telxiraTheme';
import { useRoutes } from 'react-router-dom';
import MainNavBar from './MainNavBar';
import { appRoutes } from '../routes';

const MainLayout = () => {
  const routes = useRoutes(appRoutes);

  return (
    <ThemeProvider theme={telxiraTheme}>
      <CssBaseline />
      <MainNavBar />
      <Toolbar />
      <Box sx={{ p: 3 }}>{ routes }</Box>
    </ThemeProvider>
  );
};

export default MainLayout;
